(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
(function() {
  function bindCtadStructuredData() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    $(document).on('variantChange.ctadStructuredData', '[data-section-type="product"]', function(event) {
      var variant = event.variant;
      var $container = $(this);
      var $offer = $container.find('[itemprop="offers"]');
      $offer.find('[itemprop="availability"]').attr('href',
        'https://schema.org/' + (variant && variant.available ? 'InStock' : 'OutOfStock')
      );
      if (variant) {
        var productUrl = $container.attr('itemid').split('#')[0];
        $offer.attr('itemid', productUrl + '#offer-' + variant.id);
        $offer.find('[data-ctad-offer-url]').attr('href', productUrl + '?variant=' + variant.id);
        $offer.find('[itemprop="price"]').attr('content', (variant.price / 100).toFixed(2));
        var $schemaSku = $container.find('[data-ctad-product-sku]');
        if (variant.sku) {
          if (!$schemaSku.length) {
            $schemaSku = $('<meta>').attr('itemprop', 'sku').attr('data-ctad-product-sku', '').appendTo($container);
          }
          $schemaSku.attr('content', variant.sku);
        } else {
          $schemaSku.remove();
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCtadStructuredData, {once: true});
  } else {
    bindCtadStructuredData();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
